// extracted by mini-css-extract-plugin
export default {"screenshotDialog":"dcb235d4db76","screenshotWrapper":"ffe73775061a","highlight":"d4a8364e3393","highlightButton":"e6c2047007c9"};